<template>
  <div class="container h-100">
    <!-- <div>all</div> -->
    <div class="row h-100 justify-content-center align-items-center">
      <div class="col-lg-12">
        <div class="card card-custom border-0">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-lg-12 my-5">
                <div class="mx-4">
                  <div class="my-5">
                    <span class="icon status-icon cone-icon"></span>
                  </div>

                  <!-- {{ GET_NOT_SERVICEABLE }} -->
                  <h4 class="text-center fw-bolder text-navy-blue">
                    {{
                      GET_NOT_SERVICEABLE.data
                        ? GET_NOT_SERVICEABLE.data.message
                        : ""
                    }}
                  </h4>
                  <div class="text-center mt-3">
                    <!-- <strong>Sorry.</strong> -->
                    <!-- Your area is not serviceable as of the moment. Rest assured
                    that we will do our best to increase our coverage. -->

                    <!-- Your area might not be serviceable at the moment. Please tap
                    <b>SELECT LOCATION</b> to provide us with a more specific
                    area. -->
                    We need more information from you to get your exact
                    location.
                  </div>

                  <!-- <div class="text-center mt-3">
                    Select
                    <a href="#" @click.prevent="showLocation()">location</a>
                    manually.
                  </div> -->

                  <table
                    class="table table-bordered border my-5"
                    v-if="GET_NOT_SERVICEABLE_DETAILS.length > 0"
                  >
                    <tr>
                      <th colspan="2" class="text-center p-1">Details</th>
                    </tr>
                    <tr
                      v-for="(item, i) in GET_NOT_SERVICEABLE_DETAILS"
                      :key="i"
                    >
                      <th class="p-1 px-2 border">
                        {{ camelCaseToTitleCase(item.key) }}
                      </th>
                      <td class="p-1 px-2 border">{{ item.value }}</td>
                    </tr>
                  </table>

                  <div class="my-5 text-center">
                    <!-- <button
                      class="btn btn-s2s-blue me-2 px-5"
                      @click.prevent="showLocation()"
                    >
                      Continue
                    </button> -->
                    <button
                      class="btn px-5 btn-s2s-blue"
                      @click.prevent="closeMe()"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LocationModal ref="locationModal" />
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
// import ModalMaps from "../components/ModalMaps.vue";
import LocationModal from "../components/LocationModal.vue";
export default {
  components: {
    // ModalMaps,
    LocationModal,
  },

  data() {
    return {
      modalMaps: {
        isShow: false,
      },

      accountNumber: "",
      submitted: false,
    };
  },

  methods: {
    closeMe() {
      this.$emit("closeModal", { action: "close" });
    },
    camelCaseToTitleCase(input) {
      // Split camelCase string by uppercase letters
      let words = input.split(/(?=[A-Z])/);

      // Capitalize the first letter of each word and join them with a space
      let capitalizedString = words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      return capitalizedString;
    },
    goBack() {
      this.$store
        .dispatch("ADD_NOT_SERVICEABLE", { show: false, data: {} })
        .then(() => {
          this.$router.push({ path: "/" });
        });
    },

    reFormatAccountNumber(num) {
      return num.replace(/\s+/g, "").replace("+", "");
    },

    async showLocationModal() {
      await this.$refs.locationModal.open();
    },

    showLocation() {
      this.showLocationModal();
    },
  },

  created() {},

  validations: {
    accountNumber: {
      required,
    },
  },

  computed: {
    GET_NOT_SERVICEABLE_DETAILS() {
      const actualData = this.$store.getters.GET_NOT_SERVICEABLE;
      console.log(actualData);
      const data = actualData?.data?.data?.nap;
      let tableData = [];
      for (const key in data) {
        console.log(data);
        // eslint-disable-next-line no-prototype-builtins
        // if (data.hasOwnProperty(key)) {
        tableData.push({ key: key, value: data[key] });
        // }
      }
      return tableData;
    },
    GET_NOT_SERVICEABLE() {
      return this.$store.getters.GET_NOT_SERVICEABLE;
    },
  },
};
</script>

<style scoped>
/* @import "../assets/css/reset.css";
@import "../assets/css/sweetalert2.min.css";
@import "../assets/css/superwheel.min.css"; */
</style>
